import serviceApi from "../apiClient";

export const getServiceApi = () => {
  return serviceApi.get("/service/serviceList");
};
